import { type Html } from 'rune-ts';
import { ProductBadgeBase } from '../ProductBadgeBase';
import {
  ProductBadgeColorVariants,
  ProductBadgeShape,
  ProductBadgeStyleHelper,
} from '../ProductBadgeStyleHelper.ts';

/**
 * "품절" 상품 뱃지
 */
export class SoldOutBadge extends ProductBadgeBase<undefined> {
  protected setLabel(): void {
    this.label = ET('mps2::product::badge::sold_out', { lng: this.data.option.lang });
  }

  isTimerNeeded(): boolean {
    return false;
  }

  getIcon(): Html | string | null {
    return null;
  }

  getTypo() {
    return ProductBadgeStyleHelper.getBaseTypo(this.data.option.size);
  }

  colorVariant(): ProductBadgeColorVariants {
    return ProductBadgeColorVariants.GRAY_FILLED;
  }

  shape() {
    return ProductBadgeShape.RECTANGLE;
  }
}
